import React from 'react';
import { Circle } from '@react-google-maps/api';

const ScannerCircle = ({ center, radius, visible = true }) => {
  if (!center || !visible) return null;

  // Ensure radius is a number
  const radiusNum = Number(radius);

  const options = {
    strokeColor: '#00F0FF', // NASA Cyan
    strokeOpacity: 0.9,
    strokeWeight: 3,
    fillColor: '#00F0FF',
    fillOpacity: 0.3,
    clickable: false,
    draggable: false,
    editable: false,
    visible: true,
    zIndex: 1
  };

  return (
    <Circle
      center={center}
      radius={radiusNum}
      options={options}
    />
  );
};

export default ScannerCircle;
